import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const project = useConnect('project.byId', {
    id: Number(match.params.projectId)
  });

  if (project.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      project={project}
      page="Documents"
      title="Do you have any supporting documents to help partners understand your project?"
      description={(
        <>
          <span className="font-semibold italic">TIP</span>: The most useful documents will help
          the partner understand you and your students' ideas and needs. You can always provide
          more logistical information after you've connected. This is a great place to include
          examples from previous years, student questions, etc.
        </>
      )}
    >
      <Form
        user={user}
        project={project}
        navigation={(
          <Navigation v5={true} activeStep={16} steps={19}/>
        )}
        onPrevious={(newData) => history.push(Urls(project).LOCATION)}
        onNext={(newData) => history.push(Urls(project).RESOURCES)}
        onSkip={() => history.push(Urls(project).RESOURCES)}
        onExit={() => history.push(Urls(project).PROJECT_EDIT)}
      />
    </ParentLayout>
  );
};
